import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

import { CONFIGURATION_VARIABLE_FRAGMENT } from 'graphql/fragments/configuration-variable';
import { Query as RootQuery } from 'graphql/models/generated';

export const SELECTOR_FILTER = gql`
  query selectorFilter(
    $documentVersion: DocumentVersionInput!,
    $lineId: String!
  ) {
    quotes {
      quote(documentVersion: $documentVersion) {
        line(id: $lineId) {
          id
          ... on ProductLine {
            id
            configuration {
              filteredVariables(
                filter: { isVisible: true }
                paging: { page: 0, perPage: 250 }
              ) {
                items {
                  ...ConfigurationVariableFragment
                }
              }
            }
          }
        }
      }
    }
  }
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class SelectorFilterQuery extends Query<RootQuery> {
  document = SELECTOR_FILTER;
}
